import { SUSTAINABILITY, LIFESTYLE } from "@/data/products";
import { Leaf } from "lucide-react";

export default function Sustainability() {
  return (
    <div data-testid="sustainability-page">
      <section className="relative pt-20 pb-24 bg-emerald-950 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-30">
          <img src={LIFESTYLE.outdoor} alt="" className="w-full h-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-emerald-950/40 to-emerald-950" />
        <div className="relative max-w-5xl mx-auto px-6">
          <div className="eyebrow text-gold-300 mb-4">Sustainability</div>
          <h1 className="font-display font-bold text-5xl lg:text-7xl tracking-tighter leading-[0.95]">
            Refresh the world.<br /><span className="gold-gradient-text">Preserve the planet.</span>
          </h1>
          <p className="mt-6 text-lg text-emerald-100 max-w-2xl leading-relaxed">
            Sustainability is not a programme &mdash; it&rsquo;s a principle. Every SBC decision considers the environment, our people and the communities we serve.
          </p>
        </div>
      </section>

      <section className="py-24 bg-background">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {SUSTAINABILITY.map((s) => (
            <div key={s.title} className="p-6 rounded-2xl border border-border hover:border-emerald-500 transition-colors">
              <div className="w-10 h-10 rounded-full bg-emerald-500/10 flex items-center justify-center mb-4">
                <Leaf className="w-5 h-5 text-emerald-600" />
              </div>
              <div className="font-display font-bold text-xl">{s.title}</div>
              <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
